/**
 * Sends a payment success notification email via the form submission API.
 * Called after any successful payment (course, shop, donation).
 */
export interface PaymentEmailPayload {
  email: string;
  name?: string;
  orderId: string;
  itemName: string;
  amount: number;
  payMethod: string;
  type: 'course' | 'shop' | 'donation';
}

export async function sendPaymentSuccessEmail(payload: PaymentEmailPayload): Promise<void> {
  const payMethodLabel: Record<string, string> = {
    wechat: '微信支付',
    alipay: '支付宝',
    credit: '信用卡',
    debit: '借记卡',
    card: '银行卡',
  };

  const typeLabel: Record<string, string> = {
    course: '课程购买',
    shop: '商品购买',
    donation: '爱心捐款',
  };

  const body = new URLSearchParams();
  body.append('email', payload.email);
  body.append('name', payload.name || '用户');
  body.append('order_id', payload.orderId);
  body.append('item_name', payload.itemName);
  body.append('amount', `¥${payload.amount}`);
  body.append('pay_method', payMethodLabel[payload.payMethod] || payload.payMethod);
  body.append('order_type', typeLabel[payload.type] || payload.type);
  body.append('order_time', new Date().toLocaleString('zh-CN'));

  try {
    await fetch('https://readdy.ai/api/form/d7crs5mm3fsfopf23im0', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });
  } catch {
    // Silent fail - don't block payment success flow
  }
}

export function generateOrderId(prefix = 'ORD'): string {
  const now = new Date();
  const date = now.toISOString().slice(0, 10).replace(/-/g, '');
  const rand = Math.floor(Math.random() * 9000) + 1000;
  return `${prefix}${date}${rand}`;
}
